import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ButtonComponent from "../Button";
import { HiOutlineLockClosed } from "react-icons/hi";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { ContainerFormLoginStyle } from "./style";
import { useState } from "react";

function FormLogin({ setLogged }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <ContainerFormLoginStyle>
      <Form>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1">@</InputGroup.Text>
            <Form.Control
              placeholder="Recipient's username"
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
            />
            <InputGroup.Text id="basic-addon2">@t2mlab.com</InputGroup.Text>
          </InputGroup>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicPassword">
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1">
              <HiOutlineLockClosed />
            </InputGroup.Text>
            <Form.Control
              type={showPassword ? "text" : "password"}
              placeholder="Recipient's username"
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
            />
            <InputGroup.Text
              id="basic-addon2"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <BsEye /> : <BsEyeSlash />}
            </InputGroup.Text>
          </InputGroup>
        </Form.Group>
        <Row>
          <Col className="d-flex justify-content-center mt-3">
            <ButtonComponent
              size="18rem"
              bgColor="var(--verde-primario)"
              textColor="#FFF"
              action={setLogged}
            >
              Entrar
            </ButtonComponent>
          </Col>
        </Row>
        <p className="mt-3">
          Esqueci minha senha <a href="null">Recuperar senha</a>
        </p>
      </Form>
    </ContainerFormLoginStyle>
  );
}

export default FormLogin;
